import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class InfologService {
  messages = signal<InfologMessage[]>([]);

  add(message: string, type: InfologType = 'info'): void {
    const current = this.messages();
    // Skip if the last message is identical or if the message is empty/whitespace
    const last = current[current.length - 1];
    if (!message || (last && last.message === message && last.type === type)) {
      return;
    }
    const entry: InfologMessage = {
      id: new Date().getTime().toString(),
      message,
      type,
      timestamp: new Date(),
    };
    this.messages.update(current => [...current, entry]);
  }

  success(message: string) { this.add(message, 'success'); }
  error(message: string) { this.add(message, 'error'); }
  warning(message: string) { this.add(message, 'warning'); }
  info(message: string) { this.add(message, 'info'); }

  remove(id: string): void {
    this.messages.update(current => current.filter(m => m.id !== id));
  }

  clearAll(): void {
    this.messages.set([]);
  }
}
export type InfologType = 'success' | 'error' | 'warning' | 'info';

export interface InfologMessage {
  id: string;
  message: string;
  type: InfologType;
  timestamp: Date;
}